import { useMemo } from 'react';
import { prop } from 'ramda';

import { useAppSelector } from 'js/store/hooks';

export const useShowingMode = () => {
    const { enableCookiesAdmission, enablePresistentCookieLayer } = useAppSelector(prop('cookiesConfiguration'));

    return useMemo(() => {
        if (!enableCookiesAdmission) {
            return 'hidden';
        } else if (!enablePresistentCookieLayer) {
            return 'common';
        }

        return 'persistent';
    }, [enableCookiesAdmission, enablePresistentCookieLayer]);
};
